import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { routeIdSelector, disabledCitiesSelector } from 'reduxModules/selectors/RouteSelectors'
import { isPartnerSelector, isLimitedDispatcherSelector } from 'reduxModules/selectors/UserSelectors'
import {
  toCityIdSelector,
  allCitiesSelector,
  fromCityIdSelector,
  routeCitiesSelector
} from 'reduxModules/selectors/CitySelectors'
import { toSelector, fromSelector } from 'reduxModules/selectors/BookFormSelectors'

import { CitiesFieldsBase } from './CitiesFields'

const mapStateToProps = createStructuredSelector({
  to: toSelector,
  from: fromSelector,
  routeId: routeIdSelector,
  toCityId: toCityIdSelector,
  isPartner: isPartnerSelector,
  allCities: allCitiesSelector,
  fromCityId: fromCityIdSelector,
  routeCities: routeCitiesSelector,
  disabledCities: disabledCitiesSelector,
  isLimitedDispatcher: isLimitedDispatcherSelector,
})

export const CitiesFields = connect(mapStateToProps)(CitiesFieldsBase)



// WEBPACK FOOTER //
// ./src/components/CitiesFields/index.js